"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RelayDebugLogger;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _js = require("@adeira/js");

var _logGroup = _interopRequireDefault(require("./logGroup"));

/* eslint-disable no-console */
function RelayDebugLogger(logEvent) {
  if (!(process.env.NODE_ENV !== "production") || !(0, _js.isBrowser)()) {
    return;
  }

  var name = logEvent.name,
      logEventParams = (0, _objectWithoutProperties2.default)(logEvent, ["name"]); // this logger simply logs everything

  (0, _logGroup.default)("[Relay] ".concat(logEvent.name), function () {
    console.log(logEventParams);
  });
}